export default __webpack_public_path__ + "assets/images/ilustracao-cadastro1da4d5d96d19216fcdd5f3c128b32329.png";